import Slider from 'react-slick';

import theaterTalksSettings from './theater-talks-settings';

function TheaterTalks({ children }) {
  if (!children || !children.length) {
    return null;
  }
  if (typeof DrupalGutenberg !== 'undefined' && children.length < 6) {
    // Gutenberg is crashing when responsive settings are changed.
    theaterTalksSettings.infinite = false;
    theaterTalksSettings.arrows = false;
  } else if (
    children.length < 6 &&
    theaterTalksSettings.responsive[0]?.settings
  ) {
    theaterTalksSettings.infinite = false;
    theaterTalksSettings.arrows = false;
    theaterTalksSettings.responsive[0].settings.arrows = true;
    if (children.length < 3) {
      theaterTalksSettings.responsive[0].settings.centerMode = false;
    }
    if (children.length >= 2 && typeof window !== 'undefined') {
      theaterTalksSettings.responsive.splice(1, 1);
      theaterTalksSettings.responsive[0].settings.infinite = true;
      const margins = window.innerWidth > 768 ? 84 * 2 : 20 * 2;
      theaterTalksSettings.responsive[0].breakpoint =
        margins + 280 * children.length;
    }
  }

  return (
    <div className="auo-theater-talks">
      <Slider {...theaterTalksSettings}>{children}</Slider>
    </div>
  );
}

export default TheaterTalks;
